export default "__VITE_ASSET__Vi2cgRVJ__"